<template>
  <div class="fs-site">

    <el-row class="fs-entry-header">
      <el-col :span="4" class="fs-close" @click.native="closePage">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </el-col>
      <el-col :span="16" class="text-center">
        <h1 class="text-title--large">{{ $t('pageQR.title') }}</h1>
      </el-col>
    </el-row>

    <el-row class="fs-entry-content">
      <el-col class="text-center">
        <p class="text-heading--med ma--0 pt--5 pb--2 px--8">{{ $t('pageQR.description') }}</p>
      </el-col>
      <div class="fs-contain-center">
        <el-col class="mb-2 border-qr">
          <el-row>
             <img class="imgqr" :src="QRDetail.image">
          </el-row>
        </el-col>
      </div>
      <el-col class="desc-qr pa-0 mb-2">
        <el-row class="mb-2">
          <el-col>
            <h4 class="text-heading3--bold">{{ $t('pageQR.topic') }}</h4>
          </el-col>
          <el-col class="text-heading3">
            <label>1. {{ $t('pageQR.topic1') }}</label><br>
            <label>2. {{ $t('pageQR.topic2') }}</label><br>
            <label>3. {{ $t('pageQR.topic3') }}</label><br>
            <label>4. {{ $t('pageQR.topic4') }}</label>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col>
            <a :href="QRDetail.image" download>
              <fullButton :handleClick="() => {}" :btn_text="'ดาวน์โหลด QR Code'" />
            </a>
          </el-col>
        </el-row> -->
        <el-row class="mb-2">
          <el-col class="text-center">
            <label class="text-heading3">{{ $t('pageQR.footer') }}</label><br>
          </el-col>
        </el-row>
        <el-row class="recheck">
          <el-col>
            <fullButton :bgcolor="'fs-bg-link'" :handleClick="checkQRPayment" :btn_text="$t('pageQR.btnfooter')" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <Dialog
      v-if="isOpenDialog"
      @toggleDialog="toggleDialog"
      :dialogConfirm="false"
      :dialogTitle="$t('dialog.pageQR.title')"
      :dialogText="dialogText"
      :dialogSrc="'icons/restaurant_close.png'"
      :dialogRedirect="[]"
      :btnText="$t('dialog.ok')"
    />
  </div>
</template>
<script>
import fullButton from '@/components/element/fullButton'
import Dialog from '@/components/dialog/Dialog'

export default {
  name: 'PaymentQRPage',
  props: ['restaurant_uuid', 'branch_uuid'],
  components: {
    fullButton,
    Dialog
  },
  data () {
    return {
      isOpenDialog: false
    }
  },
  mounted () {
    // localStorage.setItem('cflag-' + this.BranchDetail.id, JSON.stringify(0))
    this.$store.dispatch('clearCart')
  },
  methods: {
    toggleDialog() {
      this.isOpenDialog = !this.isOpenDialog
    },
    closePage () {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/order/history` })
    },
    downloadQRCode () {},
    checkQRPayment () {
      this.$store.dispatch('recheckQRPayment', { rcp: this.$route.query.rcp, unq: this.$route.query.unq, uid: this.$route.query.uid }).then((response) => {
        if (response) {
          this.$notify({
            title: this.$t('notify.success'),
            customClass: 'fs-notify fs-success-notify',
            iconClass: 'fs-notification',
            duration: 4000,
            type: 'success',
            showClose: false
          })
          this.closePage()
        } else {
          this.$notify({
            title: this.$t('notify.warning'),
            customClass: 'fs-notify fs-warning-notify',
            iconClass: 'fs-notification',
            duration: 4000,
            type: 'warning',
            showClose: false
          })
        }
      })
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    QRDetail () {
      return this.$store.getters.QRDetail
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/payment/PaymentQRPage.vue